import { render, staticRenderFns } from "./secondedDetails.vue?vue&type=template&id=45d30f44&scoped=true"
import script from "./secondedDetails.vue?vue&type=script&lang=js"
export * from "./secondedDetails.vue?vue&type=script&lang=js"
import style0 from "./secondedDetails.vue?vue&type=style&index=0&id=45d30f44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d30f44",
  null
  
)

export default component.exports